/**
 * Binds the persisted Ask panel state to the signed-in user.
 *
 * zustand's `persist` writes one localStorage key per origin and has no idea who is
 * signed in. Without this, signing out and back in as someone else would inherit the
 * previous user's panel width — and, far worse, their conversation history, which can
 * quote company data. On a shared machine that is a leak, so the store discards
 * everything when the owner changes rather than trying to merge.
 *
 * Runs on every render of Layout but `claimFor` is a no-op when the id already matches,
 * so this settles once per session.
 */
import { useEffect } from 'react'

import { useAskStore } from 'ask'

import { useAuth } from './useAuth'

export const useAskOwner = () => {
  const claimFor = useAskStore(s => s.claimFor)
  const { profile } = useAuth()
  const userId = profile?.id ?? null

  useEffect(() => {
    // Wait for a real id. Claiming with `null` while the profile is still loading would
    // wipe the store on every page load, defeating the point of persisting it.
    if (!userId) return
    claimFor(userId)
  }, [userId, claimFor])
}
